import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function UserRoute({ children }) {
  const user = useSelector((state) => state.user);

  if (!user || !user.id) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
